import React from 'react';

import { IGatsbyImageData } from 'gatsby-plugin-image';

import GatsbyImageTag from "components/partials/parts/gatsby-image-tag";

// import types
import { SvgLogoImage } from "types/svg-logo-image";

// NOTE: SVG Logo will take precedence over image
type SponsorBarProps = {
    text_before?: string;
    text_after?: string;
    alt_text?: string;

    /**
     * The image to be displayed.
     * Width: 296px
     * Height: 50px
     */
    image?: IGatsbyImageData;
    svgLogoImage?: SvgLogoImage;
};

const SponsorBar: React.FC<SponsorBarProps> = ({ text_before, text_after, alt_text = '', image, svgLogoImage }) => {

    return (
        <div className="pattern pattern--pad pattern--sponsor-bar">
            <div className="container">
                {text_before && <span>{text_before}</span>}
                {svgLogoImage && <div className="sponsor-image"><GatsbyImageTag image={image} svgLogoImage={svgLogoImage} alt={alt_text} /></div>}
                {text_after && <span>{text_after}</span>}
            </div>
        </div>
    );
};

export default SponsorBar;
